import { useFormikContext } from "formik";
import React, { useEffect, useState} from "react";
import styled from "styled-components";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useSelector } from "react-redux";
import { GetQualificationOptions, GetSchoolListCancelToken } from "../../../../services/RegistrationService";
import { FORM_DATE_FORMAT } from "../../../../utils/Constants";
import { addDays } from "date-fns";
import RenderPreviousValues from "./RenderPreviousValues";
import axios from "axios";
import MatchedCoursesTable from "./MatchedCoursesTable";
import QualificationCard from "./QualificationCard";
import SkeletonLoaderBasic from "../../../../loaders/SkeletonLoaderBasic";
import Checkbox from "../../../../components/library/Checkbox";
import SelectDropdown from "../../../../components/library/SelectDropdown";
import TextInput from "../../../../components/library/TextInput";
import { tokens } from "../../../../public/tokens";

// Styled components for spacing
const FormField = styled.div`
  margin-bottom: 24px;
`;

const CheckboxWrapper = styled.div`
  padding-top: ${tokens.globals["spacing-md"]};
`;

function RegistrationDetails({ studentData, salesPerson, allBrands, school, isAcademicDepartment, invoiceData }) {
  const dropdownValues = useSelector((state) => state.registerDropdownValues);
  const [intakeArr, setIntakeArr] = useState([]);
  const [startDate, setStartDate] = useState(new Date());
  const [qualOption, setQualOption] = useState([]);
  const [schoolId, setSchoolId] = useState();
  const [schoolValue, setSchoolValue] = useState("");
  const [status, setStatus] = useState("");
  const [studentStartDate, setStudentStartDate] = useState(new Date());
  const [studentEndDate, setStudentEndDate] = useState(new Date());
  const [isPMCLinked, setIsPMCLinked] = useState(false);
  const [schoolList, setSchoolList] = useState([]);
  const AcademicLearningMethod = useSelector((state) => state.registerDropdownValues.study_type_2);
  const ShortLearningMethod = useSelector((state) => state.registerDropdownValues.study_type);
  
  function getValue(arrName, label) {
    let labelName = "";
    for (let item of dropdownValues[arrName]) {
      if (item.value.toString() == label.toString()) {
        labelName = item.label;
        break;
      }
    }
    
    if (labelName === "" && arrName === "re_registration_status") return label;
    return labelName;
  }
  
  const fixNetsuiteArr = (arr) => {
    let tempArr = [];
    arr.map((item) => {
      let singleItem = {
        value: item.id,
        label: item.displayname,
        departmentId: item.department,
      };
      tempArr.push(singleItem);
    });
    setQualOption(oldVal => [...oldVal, ...tempArr]);
  };
  
  useEffect(() => {
    if (dropdownValues) {
      let tempIntakeArr = []
      dropdownValues.intake_year.map(year => {
        dropdownValues.intake_number.map(number => {
          tempIntakeArr.push({ value: `${year.value}/${number.label}`, label: `${year.value}-${number.label}` })
        })
      })
      setIntakeArr(tempIntakeArr)
    }
  }, [dropdownValues])
  
  useEffect(() => {
    if (schoolId) {
      GetQualificationOptions(schoolId).then(res => {
        fixNetsuiteArr(res && res.data && res.data.data && res.data.data.items ? res.data.data.items : []);
      })
    }
  }, [schoolValue])
  
  useEffect(() => {
    const cancelTokenSources = [];
    const getData = async () => {
      
      cancelTokenSources.forEach(source => {
        source.cancel('New request made');
      });
      
      const source = axios.CancelToken.source();
      cancelTokenSources.push(source);
      try {
        const res = await GetSchoolListCancelToken(source.token)
        if (res.status == 200) {
          const respData = res.data.data;
          respData.push({ value: "academic", label: "Academic", netsuite_department_id: 14 });
          setSchoolList(respData);
          if(isAcademicDepartment){
            setSchoolId(14);
            setSchoolValue("academic");
          }else{
            respData.map((item) => {
              if (item.value === school) {
                setSchoolId(item.netsuite_department_id)
                setSchoolValue(item.value)
                return;
              }
            })
          }
        }
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error(error);
        }
      }
    }
    
    getData();
    
    return () => {
      cancelTokenSources.forEach(source => {
        source.cancel('Component unmounted');
      });
    };
  }, [school, isAcademicDepartment])
  
  useEffect(() => {
    if(studentData?.IsPMCLinked){
      setIsPMCLinked(studentData?.IsPMCLinked)
    }
    if (studentData && salesPerson) {
      formik.setFieldValue("early_bird_discount", studentData?.re_reg_data?.early_bird_discount);
      let time = studentData?.re_reg_data?.created_date;
      if (!(studentData?.re_reg_data?.created_date.length > 10)) {
        time = (parseInt(studentData?.re_reg_data?.created_date) * 1000)
      }
      setStartDate(time);
      if (studentData?.re_reg_data && studentData?.re_reg_data.status) {
        setStatus(getValue("re_registration_status", studentData?.re_reg_data.status));
      }
      let studentStartTime = studentData?.re_reg_data?.start_date;
      if (studentStartTime && !(studentStartTime > 10)) {
        studentStartTime = (parseInt(studentStartTime) * 1000)
      }
      setStudentStartDate(studentStartTime);
      let studentEndTime = studentData?.re_reg_data?.end_date;
      if (studentEndTime && !(studentEndTime.length > 10)) {
        studentEndTime = (parseInt(studentEndTime) * 1000)
      }
      setStudentEndDate(studentEndTime);
    }    
  }, [studentData, salesPerson]);
  
  const formik = useFormikContext()
  
  const setDate = (date) => {
    setStartDate(date)
    formik.setFieldValue("submission_date", date)
  }

  const getError = (field) => {
    return formik.errors[field] && formik.touched[field] ? formik.errors[field] : "";
  };
  const showError = (field) => Boolean(formik.errors[field] && formik.touched[field]);
  
  if (!(dropdownValues?.type_course)) {
    return <SkeletonLoaderBasic />;
  }

  return (
    <div className="my-tickets-info-list Tickets-main-wrap">
    <div className="edit-icon new-card-header">
    <div className="card-header">Registration Details</div>
    </div>
    <div className="row">
    <div className="col-md-6 col-lg-4">
      <FormField>
        <SelectDropdown
          id="school"
          label="School"
          name="school"
          options={schoolList.map(item => ({ value: item.value, label: item.label }))}
          value={formik.values.school_id || ""}
          onChange={(event) => {
            const selected = schoolList.find(item => item.value === event.target.value);
            if (selected) {
              formik.setFieldValue("school", selected.label);
              formik.setFieldValue("school_id", selected.value);
              setSchoolId(selected.netsuite_department_id);
              setSchoolValue(selected.value);
            } else {
              formik.setFieldValue("school", "");
              formik.setFieldValue("school_id", "");
              setSchoolId("");
              setSchoolValue("");
            }
            formik.setFieldValue("qualification", "");
            formik.setFieldValue("netsuite_department_id", "");
            setQualOption([]);
          }}
          onBlur={formik.handleBlur}
          placeholder="Select"
          error={showError("school")}
          errorText={getError("school")}
          required
        />
      </FormField>
      <RenderPreviousValues status={studentData?.re_reg_data?.status} currentValue={studentData?.re_reg_data?.academy} previousValue={studentData?.RegStudentsPreviousDetails?.academy} type="dropdown" typeSupportingProps={{filterArray : schoolList}} />
    </div>
    <div className="col-md-6 col-lg-4">
      <FormField>
        <SelectDropdown
          id="qualification"
          label={isAcademicDepartment ? "Product" : "Qualification"}
          name="qualification"
          options={qualOption.map(item => ({ value: item.value.toString(), label: item.label }))}
          value={formik.values.qualification ? formik.values.qualification.toString() : ""}
          onChange={(event) => {
            const selected = qualOption.find(item => item.value.toString() === event.target.value);
            if (selected) {
              formik.setFieldValue("qualification", selected.value);
              formik.setFieldValue("netsuite_department_id", selected.departmentId);
            } else {
              formik.setFieldValue("qualification", "");
              formik.setFieldValue("netsuite_department_id", "");
            }
          }}
          onBlur={formik.handleBlur}
          placeholder="Select"
          error={showError("qualification")}
          errorText={getError("qualification")}
          required={(status && (status == "Re-Registration" || status == "Preliminary Re-Registration"))}
          isClearable
        />
      </FormField>
      <RenderPreviousValues status={studentData?.re_reg_data?.status} currentValue={studentData?.re_reg_data?.qualification} previousValue={studentData?.RegStudentsPreviousDetails?.qualification} 
      type="dropdown" typeSupportingProps={{filterArray : qualOption, isQualification: true, oldSchoolValue: studentData?.RegStudentsPreviousDetails?.academy}} 
      />
    </div>
    <div className="col-md-6 col-lg-4 ">
      <FormField>
        <SelectDropdown
          id="course_type"
          label="Course Type"
          name="course_type"
          options={dropdownValues.type_course.map(item => ({ value: item.value, label: item.label }))}
          value={formik.values.course_type || ""}
          onChange={(event) => {
            const value = event.target.value;
            formik.setFieldValue("course_type", value);
            if (value == "mentored" && formik.values.delivery_method == "selfplaced") {
              formik.setFieldValue("delivery_method", "");
              formik.setFieldValue("delivery_method_id", "");
            }
          }}
          onBlur={formik.handleBlur}
          placeholder="Select"
          error={showError("course_type")}
          errorText={getError("course_type")}
          required
          isClearable
        />
      </FormField>
      <RenderPreviousValues status={studentData?.re_reg_data?.status} currentValue={studentData?.re_reg_data?.course_type} previousValue={studentData?.RegStudentsPreviousDetails?.course_type} type="dropdown" typeSupportingProps={{filterArray : dropdownValues.type_course}} />
    </div>
    <div className="col-md-6 col-lg-4">
      <FormField>
        <SelectDropdown
          id="delivery_method"
          label="Learning Method"
          name="delivery_method"
          options={(formik.values.course_type === "shortcourse" ? ShortLearningMethod : AcademicLearningMethod).map(item => ({ value: item.value, label: item.label }))}
          value={formik.values.delivery_method || ""}
          onChange={(event) => {
            const selected = (formik.values.course_type === "shortcourse" ? ShortLearningMethod : AcademicLearningMethod).find(item => item.value === event.target.value);
            if (selected) {
              formik.setFieldValue("delivery_method", selected.value);
              formik.setFieldValue("delivery_method_id", selected.label);
            } else {
              formik.setFieldValue("delivery_method", "");
              formik.setFieldValue("delivery_method_id", "");
            }
          }}
          onBlur={formik.handleBlur}
          placeholder="Select"
          error={showError("delivery_method")}
          errorText={getError("delivery_method")}
          required
          isClearable
        />
      </FormField>
      <RenderPreviousValues status={studentData?.re_reg_data?.status} currentValue={studentData?.re_reg_data?.delivery_methode} previousValue={studentData?.RegStudentsPreviousDetails?.delivery_methode} type="dropdown" typeSupportingProps={{filterArray : formik.values.course_type === "shortcourse" ? ShortLearningMethod : AcademicLearningMethod}} />
    </div>

    <div className="col-md-6 col-lg-4">
      <FormField>
        <SelectDropdown
          id="building_id"
          label="Location"
          name="building_id"
          options={dropdownValues.program_campus.map(item => ({ value: item.value, label: item.label }))}
          value={formik.values.building_id || ""}
          onChange={(event) => {
            formik.setFieldValue("building_id", event.target.value);
          }}
          onBlur={formik.handleBlur}
          placeholder="Select"
          required
          isClearable
        />
      </FormField>
      <RenderPreviousValues status={studentData?.re_reg_data?.status} currentValue={studentData?.re_reg_data?.building_id} previousValue={studentData?.RegStudentsPreviousDetails?.building_id} type="dropdown" typeSupportingProps={{ filterArray: dropdownValues.program_campus }} />
    </div>

    {formik.values.course_type == "mentored" ?
      <div className="col-md-6 col-lg-4">
        <FormField>
          <SelectDropdown
            id="intake"
            label="Intake"
            name="intake"
            options={intakeArr.map(item => ({ value: item.value, label: item.label }))}
            value={formik.values.intake || ""}
            onChange={(event) => {
              formik.setFieldValue("intake", event.target.value);
            }}
            onBlur={formik.handleBlur}
            placeholder="Select"
            error={showError("intake")}
            errorText={getError("intake")}
            required={formik.values.course_type !== "shortcourse"}
            isClearable
          />
        </FormField>
        <RenderPreviousValues status={studentData?.re_reg_data?.status} currentValue={studentData?.re_reg_data?.intake_year && studentData?.re_reg_data?.intake_number ? `${studentData?.re_reg_data?.intake_year}/${studentData?.re_reg_data?.intake_number}` : ''} previousValue={studentData?.RegStudentsPreviousDetails?.intake_year && studentData?.RegStudentsPreviousDetails?.intake_number ? `${studentData?.RegStudentsPreviousDetails?.intake_year}/${studentData?.RegStudentsPreviousDetails?.intake_number}` : ''} type="dropdown" typeSupportingProps={{filterArray : intakeArr, from: "intake"}} />
      </div>
      : <></>}
      
      <div className="col-md-6 col-lg-4">
        <FormField>
          <TextInput
            id="submission_date"
            label="Submission Date"
            name="submission_date"
            value={startDate ? new Date(startDate).toISOString().split('T')[0] : ""}
            disabled
            type="date"
          />
        </FormField>
        <RenderPreviousValues status={studentData?.re_reg_data?.status} currentValue={studentData?.re_reg_data?.created_date} previousValue={studentData?.RegStudentsPreviousDetails?.created_date} typeSupportingProps={{from: "date"}}  />
      </div>
      
      <div className="col-md-6 col-lg-4">
        <FormField>
          <SelectDropdown
            id="finance_option"
            label="Finance Option"
            name="finance_option"
            options={dropdownValues.finance_option_chosen.map(item => ({ value: item.value, label: item.label }))}
            value={formik.values.finance_option_id || ""}
            onChange={(event) => {
              formik.setFieldValue("finance_option", event.target.value);
              formik.setFieldValue("finance_option_id", event.target.value);
            }}
            onBlur={formik.handleBlur}
            placeholder="Select"
            error={showError("finance_option")}
            errorText={getError("finance_option")}
            isClearable
          />
        </FormField>
        <RenderPreviousValues status={studentData?.re_reg_data?.status} currentValue={studentData?.re_reg_data?.finance_option_chosen} previousValue={studentData?.RegStudentsPreviousDetails?.finance_option_chosen} type="dropdown" typeSupportingProps={{filterArray : dropdownValues.finance_option_chosen}} />
      </div>
      <div className="col-md-6 col-lg-4">
        <FormField>
          <SelectDropdown
            id="laptop"
            label="Laptop"
            name="laptop"
            options={dropdownValues.laptop.map(item => ({ value: item.value, label: item.label }))}
            value={formik.values.laptop || ""}
            onChange={(event) => {
              formik.setFieldValue("laptop", event.target.value);
              formik.setFieldValue("laptop_id", event.target.value);
            }}
            onBlur={formik.handleBlur}
            placeholder="No Laptop Required"
            error={showError("laptop")}
            errorText={getError("laptop")}
            disabled
            isClearable
          />
        </FormField>
        <RenderPreviousValues status={studentData?.re_reg_data?.status} currentValue={studentData?.re_reg_data?.laptop} previousValue={studentData?.RegStudentsPreviousDetails?.laptop} type="dropdown" typeSupportingProps={{filterArray : dropdownValues.laptop}} />
      </div>
      <div className="col-md-6 col-lg-4">
        <FormField>
          <SelectDropdown
            id="brand"
            label="Brand"
            name="brand"
            options={allBrands.map(item => ({ value: item.value, label: item.label }))}
            value={formik.values.brand || ""}
            onChange={(event) => {
              formik.setFieldValue("brand", event.target.value);
              formik.setFieldValue("brand_id", event.target.value);
            }}
            onBlur={formik.handleBlur}
            placeholder="Select"
            error={showError("brand")}
            errorText={getError("brand")}
            required
            isClearable
          />
        </FormField>
        <RenderPreviousValues status={studentData?.re_reg_data?.status} currentValue={studentData?.re_reg_data?.brand_reg} previousValue={studentData?.RegStudentsPreviousDetails?.brand_reg} type="dropdown" typeSupportingProps={{filterArray : allBrands}} />
      </div>
      <div className="col-md-6 col-lg-4">
        <FormField>
          <SelectDropdown
            id="sales_person"
            label="Sales Person"
            name="sales_person"
            options={salesPerson.map(item => ({ value: item.value, label: item.label }))}
            value={formik.values.sales_person_id || ""}
            onChange={(event) => {
              const selected = salesPerson.find(item => item.value === event.target.value);
              if (selected) {
                formik.setFieldValue("sales_person", selected.label);
                formik.setFieldValue("sales_person_id", selected.value);
              } else {
                formik.setFieldValue("sales_person", "");
                formik.setFieldValue("sales_person_id", "");
              }
            }}
            onBlur={formik.handleBlur}
            placeholder="Select"
            error={showError("sales_person")}
            errorText={getError("sales_person")}
            isClearable
          />
        </FormField>
        <RenderPreviousValues status={studentData?.re_reg_data?.status} currentValue={studentData?.re_reg_data?.sale_person_id} previousValue={studentData?.RegStudentsPreviousDetails?.sale_person_id} type="dropdown" typeSupportingProps={{filterArray : salesPerson}} />
      </div>
      
      {(formik.values.course_type != "mentored" && (formik.values.course_type == "shortcourse" && formik.values.delivery_method != "selfplaced")) ?
        <>
        <div className="col-md-6 col-lg-4">
        <label htmlFor="sales_person">Start Date</label>
        <div className="form-group-blk mb-3" title="Start Date">
        <DatePicker
        autoComplete="off"
        selected={formik.values.start_date}
        name="start_date"
        onChange={(date) => {
          setStudentStartDate(date)
          formik.setFieldValue("start_date", date)
        }}
        className="form-control w-100"
        onChangeRaw={(e) => e.preventDefault()}
        dateFormat={FORM_DATE_FORMAT}
        title="Start Date"
        onBlur={formik.handleBlur}
        placeholderText="Select Start Date"
        />
        <RenderPreviousValues status={studentData?.re_reg_data?.status} currentValue={studentData?.re_reg_data?.start_date} previousValue={studentData?.RegStudentsPreviousDetails?.start_date} typeSupportingProps={{from : "date"}}/>
        </div>
        </div>
        <div className="col-md-6 col-lg-4">
        <label htmlFor="sales_person">End Date</label>
        <div className="form-group-blk mb-3" title="End Date">
        <DatePicker
        selected={studentEndDate}
        onChange={(date) => {
          setStudentEndDate(date)
          formik.setFieldValue("end_date", date)
        }}
        className="form-control w-100"
        onChangeRaw={(e) => e.preventDefault()}
        dateFormat={FORM_DATE_FORMAT}
        title="End Date"
        onBlur={formik.handleBlur}
        placeholderText="Select End Date"
        disabled={!formik.values.start_date}
        timeIntervals={15}
        minDate={addDays(formik.values.start_date, 0)}
        dateFormatCalendar="MMMM"
        />
        <RenderPreviousValues status={studentData?.re_reg_data?.status} currentValue={studentData?.re_reg_data?.end_date} previousValue={studentData?.RegStudentsPreviousDetails?.end_date} typeSupportingProps={{from: "date"}} />
        </div>
        </div>
        </> : null}
        
        {invoiceData && (
          <>
          <div className="col-md-6 col-lg-4">
            <b className="matched-purple">Latest Invoice:</b><br/>
            <b>Qualification: </b> {invoiceData?.lineItems?.[0] || "-"}<br/>
            <b>Learning Method:</b> <span className={studentData?.learningMethodWrong ? 'as-red .descriptiontextBold' : ''}>{invoiceData.learningMethod || "-"}<br/></span>
            <b>Campus:</b> <span className={studentData?.campusWrong ? 'as-red .descriptiontextBold' : ''}>{invoiceData.campus || "-"}<br/></span>
            {studentData?.re_reg_data?.course_type == 'mentored' && (<><b>Intake:</b> <span className={studentData?.intakeWrong ? 'as-red .descriptiontextBold' : ''}>{invoiceData.intake || "-"}<br/></span></>)}
          </div>
          </>
        )}

        {formik.values.course_type == "shortcourse" &&
          (<div className="col-md-6 col-lg-4">
            <label>&nbsp;</label>
            <div className="form-group-blk mb-3" style={{ paddingTop: "11px" }}>
              <label></label>
              <div className="custom-check custom-control custom-checkbox custom-control-inline">
                <CheckboxWrapper>
                  <Checkbox
                    id="credit_bearing"
                    name="select"
                    checked={formik.values.credit_bearing || false}
                    onChange={(e) => {
                      formik.setFieldValue("credit_bearing", e.target.checked ? 1 : 0)
                    }}
                    label="Credit Bearing"
                  />
                </CheckboxWrapper>
              </div>
            </div>
          </div>
        )}
      </div>
      <hr />
      <div className="form-group form-group-save-cancel">
        {isAcademicDepartment ?          
          <div>
            <b className="matched-purple">Laptop Only Registration</b>
          </div>
          : 
          <div className="max-width-fit-content">
            {!isPMCLinked && (
              (studentData?.matched_program?.length > 0)
              ? (          
                <>
                  <b>Matched Qualification / Course:</b>
                  <div className="fm-files">
                    {studentData?.matched_program?.map((item, index) => (
                      <div key={item.id}>
                        <QualificationCard
                          item={item}
                          courseType={formik.values.course_type}
                        />
                      </div>
                    ))}
                  </div>
                </>    
              )
              :  <b className="matched-red">Not Matched</b>
            )}
            {isPMCLinked && ((studentData?.matched_program?.length > 0)
              ? (  
                <>
                  <div className="matched-programs">
                    <b>{studentData?.courseMatchOldQualInfo?.length > 0 ? "Term 1 Modules:" : "Matched Qualification"}</b>
                    <div className="fm-files">
                      {studentData?.matched_program?.map((item, index) => (
                        <div key={item.id}>
                          <QualificationCard
                            item={item}
                            courseType={formik.values.course_type}
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                  {(studentData?.courseMatchInfo && studentData?.courseMatchInfo.length > 0) && (
                    <MatchedCoursesTable qualOption={qualOption} courses={studentData?.courseMatchInfo} />
                  )}
                  <hr/>
                </>
              ) 
              :  <div className="course-name">Term 1 Qualification<b className="matched-red">: Not Matched</b><hr/></div>
            )} 
            {isPMCLinked && ((studentData?.matchedLastIntakeQuals?.length > 0) ? (
              <>
                <b>Term 2 Modules:</b>
                <div className="fm-files">
                  {studentData?.matchedLastIntakeQuals?.map((item, index) => (
                    <div key={item.id}>
                      <QualificationCard
                        item={item}
                        courseType={formik.values.course_type}
                      />
                    </div>
                  ))}
                </div>
                { (studentData?.courseMatchOldQualInfo && studentData?.courseMatchOldQualInfo.length > 0) ? (
                  <MatchedCoursesTable qualOption={qualOption} courses={studentData?.courseMatchOldQualInfo} />
                ) : "N/A"}
              </>
            )
            :  <>{(studentData?.courseMatchOldQualInfo.length) > 0 && <div className="course-name">Term 2 Qualification<b className="matched-red">: Not Matched</b></div>}</>
            )}
            <hr />
          </div>
        }
      </div>
    </div>
  );
}

export default RegistrationDetails;